module.exports = __webpack_public_path__ + "img/2.a54bd2ff.svg";